import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import HelperUsers from "./HelperUsers";
import UsersProgress from "./UsersProgress";
import { useSelector } from "react-redux";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function Admin() {
  const [value, setValue] = React.useState(0);
  const respondentDetails = useSelector(
    (state) => state?.survey?.respondentDetails
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          sx={{
            "& button": { borderRadius: "10px 10px 0 0" },
            "& button:hover": { backgroundColor: "rgba(0, 48, 135, 0.05)" },
            // "& button:active": { backgroundColor: "blue" },
            "& button.Mui-selected": {
              backgroundColor: "rgba(0, 48, 135, 0.15)",
              color: "#003087",
            },
          }}
        >
          <Tab
            sx={{
              color: "#003087",
              // fontWeight: "bold",
              // textTransform: "none",
            }}
            label="create helper user"
            {...a11yProps(0)}
          />
          {respondentDetails?.canSubmitSurvey && (
            <Tab
              sx={{
                color: "#003087",
                // fontWeight: "bold",
              }}
              label="progress report"
              {...a11yProps(1)}
            />
          )}
        </Tabs>
      </Box>
      <CustomTabPanel value={value} index={0}>
        <HelperUsers />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <UsersProgress />
      </CustomTabPanel>
    </Box>
  );
}
